import { NavigateFunction } from "react-router-dom";
import { Routes } from "../constants";
import { isAdverTimesUrl } from "./string";

interface HandleRedirectParams {
  navigate: NavigateFunction;
  user_status: number;
  returnTo?: string;
  session_id?: string;
}

const BULK_DOWNLOAD_KEY = "bulkDownload";

/** Persist AdverTimes bulkDownload=true across ID login/setting (SDK_WEB-1374). Does not call the download API. */
export const persistBulkDownloadFlag = (enabled: boolean) => {
  if (enabled) {
    localStorage.setItem(BULK_DOWNLOAD_KEY, "true");
  }
};

export const shouldBulkDownload = (): boolean =>
  localStorage.getItem(BULK_DOWNLOAD_KEY) === "true";

export const returnToHasBulkDownload = (returnTo: string | null | undefined): boolean => {
  if (!returnTo) return false;
  try {
    return new URL(returnTo).searchParams.get("bulkDownload") === "true";
  } catch {
    return false;
  }
};

/** SDK_WEB-1374: new AdverTimes bulk-download gate (returnto priority). Other AdverTimes inflows keep legacy flow. */
export const isAdverTimesBulkDownloadFlow = (
  returnTo?: string | null
): boolean => {
  if (!shouldBulkDownload()) return false;
  const target = returnTo || localStorage.getItem("loginCallBackUrl");
  return isAdverTimesUrl(target);
};

/** Attach bulkDownload=true on AdverTimes return URL when the inflow asked for it. */
export const attachBulkDownloadIfNeeded = (targetUrl: URL) => {
  if (!isAdverTimesUrl(targetUrl.toString())) return;
  if (
    targetUrl.searchParams.get("bulkDownload") === "true" ||
    shouldBulkDownload()
  ) {
    targetUrl.searchParams.set("bulkDownload", "true");
  }
  localStorage.removeItem(BULK_DOWNLOAD_KEY);
};

export const handleRedirect = ({
  navigate,
  user_status = 0,
  returnTo = "",
  session_id = "",
}: HandleRedirectParams) => {
  if (user_status === 0 || user_status === 1 || user_status === 3) {
    const params = new URLSearchParams();
    if (returnTo) params.append("returnto", returnTo);
    if (session_id) params.append("session_id", session_id);
    if (shouldBulkDownload()) params.append("bulkDownload", "true");

    const linkRedirect = `${Routes.USERSETTING}${
      params.toString() ? `?${params.toString()}` : ""
    }`;
    navigate(linkRedirect);
  } else {
    localStorage.removeItem("mailmagid");
    localStorage.removeItem("session_id");
    localStorage.removeItem("loginCallBackUrl");
    localStorage.removeItem("serviceid_url");

    const url = new URL(returnTo);

    if (session_id) {
      url.searchParams.set("session_id", String(session_id));
    }
    attachBulkDownloadIfNeeded(url);

    window.location.href = url.toString();
  }
};
